import React from 'react'
// importo db para poder usar los servicios de firebase con las bases de datos
import { db } from '../firebase'
// importo moment.js para poder hacer mis fechas y hora mas formateadas
import moment from 'moment'
// ahora transformo a moment a espanol
import 'moment/locale/es'


// lla mi props --->  que es de user
const Firestore = (props) => {

    const [tareas, setTareas] = React.useState([])
    const [tarea, setTarea] = React.useState('')
    const [modoEdicion, setModoEdicion] = React.useState(false)
    const [id, setId] = React.useState('')

    // estados para mi paginacion
    const [ultimo, setUltimo] = React.useState(null)
    const [desactivar, setDesactivar] = React.useState(false)

    React.useEffect(() => {

        const obtenerDatos = async () => {

            try {

                // activo el boton
                setDesactivar(true)

                // const db = firebase.firestore()
                // accedo a la coleccion del usuario en especifico
                // .limit(#deDocumentos)---> para limitar los resultados
                const data = await db.collection(props.user.uid)
                    //.limit(#deDocumentos) ---> para hacer paginacion
                    .limit(2)
                    // ordenar los limit
                    // 'fecha' --> viene del campo de la coleccion
                    // .orderBy('fecha') // Ascendente --> del mas antiguo al mas reciente
                    .orderBy('fecha', 'desc') //Descendente ---> del mas reciente al mas antiguo
                    .get()

                // armo el array con la data
                const arrayData = data.docs.map(doc => ({ id: doc.id, ...doc.data() }))

                // guardo en estado el ultimo documento de mi colleccion mostrada por mi limit
                setUltimo(data.docs[data.docs.length - 1])

                console.log(arrayData)
                setTareas(arrayData)

                // hacemos un llamado a los datos, pintamos las tareas y las agregamos

                // luego hacemos otro llamado a la base de datos, solamente para saber si el documento viene vacio

                // Para ver si hay mas documentos por leer
                // leemos los ducumentos nuevamente
                const query = await db.collection(props.user.uid)
                    .limit(2)
                    .orderBy('fecha', 'desc') //Descendente ---> del mas reciente al mas antiguo
                    // comience despues del documento
                    .startAfter(data.docs[data.docs.length - 1])
                    .get()

                // pregunto si los documentos que estamos volviendo a preguntar esta vacio
                if (query.empty) {
                    // si esta vacio ---> no hay mas documentos
                    console.log('No hay mas documentos')
                    // por eso desactivamos el boton porque ya no hay mas documentos
                    setDesactivar(true)
                } else {
                    // en caso de que si hayan mas el boton va a estar desactivado --> porque hay mas documentos
                    setDesactivar(false)
                }

            } catch (error) {
                console.log(error)
            }

        }

        obtenerDatos()

        //[] ---> que se ejecute solo una vez
    }, [props.user.uid])

    const agregar = async (e) => {
        e.preventDefault()

        if (!tarea.trim()) {
            console.log('está vacio')
            return
        }

        try {

            // const db = firebase.firestore()
            const nuevaTarea = {
                name: tarea,
                fecha: Date.now()
            }
            const data = await db.collection(props.user.uid).add(nuevaTarea)

            setTareas([
                ...tareas,
                { ...nuevaTarea, id: data.id }
            ])

            setTarea('')

        } catch (error) {
            console.log(error)
        }

        console.log(tarea)
    }

    const eliminar = async (id) => {
        try {

            // const db = firebase.firestore()
            await db.collection(props.user.uid).doc(id).delete()

            const arrayFiltrado = tareas.filter(item => item.id !== id)
            setTareas(arrayFiltrado)

        } catch (error) {
            console.log(error)
        }
    }

    const activarEdicion = (item) => {
        setModoEdicion(true)
        setTarea(item.name)
        setId(item.id)
    }

    const editar = async (e) => {
        e.preventDefault()
        if (!tarea.trim()) {
            console.log('vacio')
            return
        }
        try {

            // const db = firebase.firestore()
            await db.collection(props.user.uid).doc(id).update({
                name: tarea
            })
            const arrayEditado = tareas.map(item => (
                item.id === id ? { id: item.id, fecha: item.fecha, name: tarea } : item
            ))
            setTareas(arrayEditado)
            setModoEdicion(false)
            setTarea('')
            setId('')
        } catch (error) {
            console.log(error)
        }
    }

    // funcion para hacer la paginacion
    const siguiente = async () => {

        console.log('siguiente')

        try {

            // const db = firebase.firestore()
            // accedo a la coleccion del usuario en especifico
            // .limit(#deDocumentos)---> para limitar los resultados
            const data = await db.collection(props.user.uid)
                //.limit(#deDocumentos) ---> para hacer paginacion
                .limit(2)
                // ordenar los limit
                // 'fecha' --> viene del campo de la coleccion
                // .orderBy('fecha') // Ascendente --> del mas antiguo al mas reciente
                .orderBy('fecha', 'desc') //Descendente ---> del mas reciente al mas antiguo
                // comience despues del documento
                .startAfter(ultimo)
                .get()


            // armo el array con la data
            const arrayData = data.docs.map(doc => ({ id: doc.id, ...doc.data() }))

            // empujo los nuevos datos de mi array al estado
            setTareas([
                // pero como debemos unir el array que ya tiene data con el nuevo array que ahora trae otra data
                ...tareas,
                // como solo queremos tener un solo array con sus elementos, por eso ...
                ...arrayData
            ])

            // guardo en estado el ultimo documento de mi colleccion mostrada por mi limit
            setUltimo(data.docs[data.docs.length - 1])

            // Para ver si hay mas documentos por leer
            // leemos los ducumentos nuevamente
            const query = await db.collection(props.user.uid)
                .limit(2)
                .orderBy('fecha', 'desc') //Descendente ---> del mas reciente al mas antiguo
                // comience despues del documento
                .startAfter(data.docs[data.docs.length - 1])
                .get()

            // pregunto si los documentos que estamos volviendo a preguntar esta vacio
            if (query.empty) {
                // si esta vacio ---> no hay mas documentos
                console.log('No hay mas documentos')
                // por eso desactivamos el boton porque ya no hay mas documentos
                setDesactivar(true)
            } else {
                // en caso de que si hayan mas el boton va a estar desactivado --> porque hay mas documentos
                setDesactivar(false)
            }

        } catch (error) {
            console.log(error)
        }

    }









    return (
        <div>
            <div className="row">
                <div className="col-md-6">
                    <h3>Lista de tareas</h3>
                    <ul className="list-group">
                        {
                            tareas.map(item => (
                                <li className="list-group-item" key={item.id}>
                                    {item.name} - {moment(item.fecha).format('LLL')}
                                    <button
                                        className="btn btn-danger btn-sm float-right"
                                        onClick={() => eliminar(item.id)}
                                    >
                                        Eliminar
                                    </button>
                                    <button
                                        className="btn btn-warning btn-sm float-right mr-2"
                                        onClick={() => activarEdicion(item)}
                                    >
                                        Editar
                                    </button>
                                </li>
                            ))
                        }
                    </ul>
                    {/* Creo un buton para la paginacion */}
                    {/* btn.btn-info.btn-block.mt-2.btn-sm */}
                    <button
                        className="btn btn-info btn-block mt-2 btn-sm"
                        // 
                        onClick={() => siguiente()}
                        // para desactivar el boton cuando ya no hay data que cargar
                        disabled={desactivar}
                    >
                        Siguiente...
                    </button>
                </div>
                <div className="col-md-6">
                    <h3>
                        {
                            modoEdicion ? 'Editar Tarea' : 'Agregar Tarea'
                        }
                    </h3>
                    <form onSubmit={modoEdicion ? editar : agregar}>
                        <input
                            type="text"
                            placeholder="Ingrese tarea"
                            className="form-control mb-2"
                            onChange={e => setTarea(e.target.value)}
                            value={tarea}
                        />
                        <button
                            className={
                                modoEdicion ? 'btn btn-warning btn-block' : 'btn btn-dark btn-block'
                            }
                            type="submit"
                        >
                            {
                                modoEdicion ? 'Editar' : 'Agregar'
                            }
                        </button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Firestore